<template>
  <div class="content mt-n10">
    <div class="md-layout">
      <div class="md-layout-item ma-0 pa-0">
        <!-- :style="{ background: $vuetify.theme.themes[theme].background }" -->
        <!-- <v-card tile elevation="0"> -->
        <div class="ma-0 pa-0 ml-5" style="display: flex">
          <div class="ma-0 pa-0">
            <h2
              style="
                opacity: 0.8;
                font-family: Nunito Sans;
                font-size: 2rem !important;
                font-weight: 1000 !important;
              "
            >
              Assets
            </h2>
          </div>
          <div class="ma-0 pa-0 mt-7 ml-8">
            <v-row class="ma-0 pa-0">
              <p
                style="
                  font-size: 13px;
                  color: #419cff;
                  font-family: Nunito Sans;
                  cursor: pointer;
                "
                v-on:click="addfile()"
              >
                Add new asset
                <v-btn icon>
                  <v-icon size="17" style="color: #419cff">mdi-plus</v-icon>
                </v-btn>
              </p>

              <v-tooltip right>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on">
                    <v-icon
                      size="17"
                      style="color: #419cff"
                      @click="multipleFilesTab()"
                      >mdi-book-plus-multiple-outline</v-icon
                    >
                  </v-btn>
                </template>
                <span>Batch Upload (Beta 1.2)</span>
              </v-tooltip>
              <div class="ma-0 pa-0 mt-2">
                <v-icon color="primary" @click="goToTheSharePages()"
                  >mdi-page-next-outline</v-icon
                >
              </div>
            </v-row>
          </div>
        </div>
        <!-- </v-card> -->

        <v-row class="ma-0 pa-0" justify="space-between">
          <!-- <v-col cols="10" style="text-align: left"> -->
          <div style="display: flex" class="ma-0 pa-0 ml-5">
            <div class="ma-0 pa-0 mt-1 ml-n1 mr-2">
              <v-icon @click="toggleSidebar()"> mdi-dots-vertical </v-icon>
            </div>
            <div class="ma-0 pa-0">
              <v-menu
                rounded="xl"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                bottom
                min-width="180"
                min-height="240"
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    outlined
                    medium
                    width="105"
                    rounded
                    class="mt-n1"
                    style="
                      text-transform: none;
                      color: #419cff;
                      font-family: Nunito Sans;
                      font-weight: 800;
                    "
                    :class="[augmentableTheme ? 'darkOutline' : 'lightOutline']"
                  >
                    Actions <v-icon>mdi-chevron-down</v-icon>
                  </v-btn>
                </template>
                <v-card
                  :style="{
                    background: $vuetify.theme.themes[theme].background,
                  }"
                  class="ma-0 pa-0"
                  min-width="180"
                  min-height="240"
                  rounded="lg"
                >
                  <div class="ma-0 pa-0" style="display: flex">
                    <v-card
                      elevation="0"
                      class="ma-0 pa-0"
                      width="170"
                      height="230"
                      color="transparent"
                    >
                      <v-row
                        v-for="(item, index) in actionMenu"
                        :key="index"
                        class="ma-0 pa-0 mb-n7 ml-1"
                      >
                        <v-col cols="2">
                          <v-icon
                            v-if="item.checked"
                            size="16"
                            color="primary"
                            @click="collectAssets(index + 1)"
                            >{{ item.icon }}</v-icon
                          >
                          <v-icon
                            v-if="!item.checked"
                            size="16"
                            @click="collectAssets(index + 1)"
                            >{{ item.icon }}</v-icon
                          ></v-col
                        >
                        <v-col cols="2">
                          <v-divider
                            vertical
                            style="border-color: #d3d3d3"
                          ></v-divider
                        ></v-col>

                        <v-tooltip
                          right
                          :disabled="
                            item.title === 'Delete' ||
                            item.title === 'Archive' ||
                            item.title === 'Download'
                          "
                        >
                          <template v-slot:activator="{ on }">
                            <v-col
                              cols="8"
                              v-on="on"
                              class="ml-n2"
                              style="margin-top: 2px"
                            >
                              <p
                                v-if="item.checked"
                                style="
                                  cursor: pointer;
                                  color: #419cff;
                                  font-weight: 700;
                                "
                                @click="collectAssets1(index)"
                              >
                                {{ item.title }}
                              </p>
                              <p
                                v-if="!item.checked"
                                style="cursor: pointer; font-weight: 700"
                                @click="collectAssets1(index)"
                              >
                                {{ item.title }}
                              </p></v-col
                            >
                          </template>
                          <span>Beta 1.2</span>
                        </v-tooltip>
                      </v-row>

                      <!-- 1st row -->
                      <!-- <v-row class="ma-0 pa-0 mb-n7 ml-1">
                        <v-col cols="2">
                          <v-icon size="16" @click="collectAssets(1)"
                            >mdi-briefcase-download-outline</v-icon
                          ></v-col
                        >
                        <v-col cols="2">
                          <v-divider
                            vertical
                            style="border-color: #d3d3d3"
                          ></v-divider
                        ></v-col>
                        <v-col cols="8" class="ml-n2" style="margin-top: 2px">
                          <p
                            style="cursor: pointer; font-weight: 700"
                            @click="collectAssets1(1)"
                          >
                            Download
                          </p></v-col
                        >
                      </v-row> -->
                      <!-- 2nd row -->
                      <!-- <v-row class="ma-0 pa-0 mb-n7 ml-1">
                        <v-col cols="2">
                          <v-icon size="16" @click="collectAssets(2)"
                            >mdi-archive-arrow-down-outline</v-icon
                          ></v-col
                        >
                        <v-col cols="2">
                          <v-divider
                            vertical
                            style="border-color: #d3d3d3"
                          ></v-divider
                        ></v-col>
                        <v-col cols="8" class="ml-n2" style="margin-top: 2px">
                          <p
                            style="cursor: pointer; font-weight: 700"
                            @click="collectAssets1(2)"
                          >
                            Convert
                          </p></v-col
                        >
                      </v-row> -->
                      <!-- 3rd row -->
                      <!-- <v-row class="ma-0 pa-0 mb-n7 ml-1">
                        <v-col cols="2"
                          ><v-icon size="16" @click="collectAssets(3)"
                            >mdi-drag-variant</v-icon
                          >
                        </v-col>
                        <v-col cols="2">
                          <v-divider
                            vertical
                            style="border-color: #d3d3d3"
                          ></v-divider
                        ></v-col>
                        <v-col cols="8" class="ml-n2" style="margin-top: 2px">
                          <p
                            style="cursor: pointer; font-weight: 700"
                            @click="collectAssets1(3)"
                          >
                            API Publish
                          </p></v-col
                        >
                      </v-row> -->
                      <!-- 4th row -->
                      <!-- <v-row class="ma-0 pa-0 mb-n7 ml-1">
                        <v-col cols="2">
                          <v-icon size="16" @click="collectAssets(4)"
                            >mdi-content-copy</v-icon
                          ></v-col
                        >
                        <v-col cols="2"
                          ><v-divider
                            vertical
                            style="border-color: #d3d3d3"
                          ></v-divider
                        ></v-col>
                        <v-col cols="8" class="ml-n2" style="margin-top: 2px">
                          <p
                            style="cursor: pointer; font-weight: 700"
                            @click="collectAssets1(4)"
                          >
                            Sharepage
                          </p></v-col
                        >
                      </v-row> -->
                      <!-- 5th row -->
                      <!-- <v-row class="ma-0 pa-0 mb-n7 ml-1">
                        <v-col cols="2"
                          ><v-icon size="16" @click="collectAssets(5)"
                            >mdi-archive-arrow-down-outline</v-icon
                          >
                        </v-col>
                        <v-col cols="2"
                          ><v-divider
                            vertical
                            style="border-color: #d3d3d3"
                          ></v-divider
                        ></v-col>
                        <v-col cols="8" class="ml-n2" style="margin-top: 2px"
                          ><p
                            style="cursor: pointer; font-weight: 700"
                            @click="collectAssets1(5)"
                          >
                            Archive
                          </p></v-col
                        >
                      </v-row> -->
                      <!-- 6th row -->
                      <!-- <v-row class="ma-0 pa-0 mb-n7 ml-1">
                        <v-col cols="2"
                          ><v-icon size="16" @click="collectAssets(6)"
                            >mdi-delete-outline</v-icon
                          >
                        </v-col>
                        <v-col cols="2"
                          ><v-divider
                            vertical
                            style="border-color: #d3d3d3"
                          ></v-divider>
                        </v-col>
                        <v-col cols="8" class="ml-n2" style="margin-top: 2px"
                          ><p
                            style="cursor: pointer; font-weight: 700"
                            @click="collectAssets1(6)"
                          >
                            Delete
                          </p></v-col
                        >
                      </v-row> -->
                    </v-card>
                    <v-divider
                      v-if="
                        download ||
                        convert ||
                        sharePage ||
                        Delete ||
                        archive ||
                        apiPublish
                      "
                      class="mt-3 mb-5"
                      vertical
                      style="border-color: #d3d3d3"
                    ></v-divider>
                    <!-- v-card for download button  -->
                    <v-card
                      elevation="0"
                      width="180"
                      height="230"
                      color="transparent"
                      class="ma-0 pa-0"
                      v-if="download"
                    >
                      <p
                        style="
                          cursor: pointer;
                          color: #419cff;
                          font-weight: 700;
                        "
                        class="ma-0 pa-0 ml-3 mt-2 mb-5 mt-4"
                      >
                        Selected {{ selected1.length }}
                      </p>
                      <div
                        class="mt-n6"
                        style="display: flex"
                        v-for="(item, index) in localitemdownload"
                        :key="index"
                      >
                        <v-row class="ml-3 mt-3">
                          <p
                            style="
                              font-size: 11px;
                              font-weight: 700;
                              text-align: left;
                            "
                          >
                            {{ item.title }}
                          </p>
                        </v-row>
                        <v-row justify="end" align="end" class="mt-n3 pr-6">
                          <v-checkbox class=""></v-checkbox>
                        </v-row>
                      </div>
                    </v-card>
                    <!-- v-card for convert button  -->
                    <v-card
                      elevation="0"
                      width="200"
                      min-height="230"
                      color="transparent"
                      class="ma-0 pa-0"
                      v-if="convert"
                    >
                      <p
                        style="
                          cursor: pointer;
                          color: #419cff;
                          font-weight: 700;
                        "
                        class="ma-0 pa-0 ml-3 mt-2 mb-5 mt-4"
                      >
                        Selected {{ selected1.length }}
                      </p>
                      <v-row class="mr-3 mt-n1">
                        <v-col cols="1"></v-col>
                        <v-col cols="7">
                          <p
                            class="ml-n2"
                            style="font-size: 11px; font-weight: 760"
                          >
                            Set File Format
                          </p>
                        </v-col>
                        <v-col
                          cols="1"
                          style="cursor: pointer"
                          @click="importmenu3 = !importmenu3"
                        >
                          <!-- <v-icon class="ml-n8 mt-n2" v-if="!importmenu1">
                            mdi-menu-right
                          </v-icon> -->
                          <v-icon class="ml-n8 mt-n2"> mdi-menu-right </v-icon>
                          <!-- <v-icon class="ml-n8 mt-n2" v-if="importmenu1">
                            mdi-menu-down
                          </v-icon> -->
                        </v-col>
                        <v-col cols="1">
                          <v-icon class="mt-n3 ml-n6"
                            >settings_input_component</v-icon
                          >
                        </v-col>
                        <v-col cols="1"></v-col>
                      </v-row>
                      <v-card
                        :style="{
                          background: $vuetify.theme.themes[theme].background,
                        }"
                        v-if="importmenu11"
                        elevation="0"
                        width="180"
                        height="85"
                        class="ml-1 mr-2 mt-n11 mb-10"
                      >
                        <v-row
                          class="pa-0 ma-0 ml-2 mb-n11"
                          v-for="(item, index) in quality"
                          :key="index"
                        >
                          <v-row class="pa-0 ma-0">
                            <v-col cols="5">
                              <p style="font-size: 11px" class="ml-n2">
                                {{ item.title }}
                              </p>
                            </v-col>
                            <v-col cols="6">
                              <p style="font-size: 11px" class="ml-n3">
                                <v-icon
                                  style="margin-top: -0.1em"
                                  @click="minquality(item)"
                                  >navigate_before</v-icon
                                >{{ item.value
                                }}<v-icon
                                  style="margin-top: -0.1em"
                                  @click="maxquality(item)"
                                  >navigate_next</v-icon
                                >
                              </p>
                            </v-col>
                            <v-col cols="1" class="mt-n6 ml-n8">
                              <v-checkbox
                                class="ml-n3"
                                v-model="item.checked"
                                @click="checkQualityValues(item)"
                              ></v-checkbox>
                            </v-col>
                          </v-row>
                        </v-row>
                      </v-card>
                      <v-row class="mt-n12">
                        <v-col cols="7">
                          <p
                            class="ml-4"
                            style="font-size: 11px; font-weight: 660"
                          >
                            Set Compression
                          </p>
                        </v-col>
                        <v-col
                          cols="1"
                          style="cursor: pointer"
                          @click="importmenu2 = !importmenu2"
                        >
                          <v-icon class="ml-n5 mt-n2" v-if="!importmenu2">
                            mdi-menu-right
                          </v-icon>
                          <v-icon class="ml-n5 mt-n2" v-if="importmenu2">
                            mdi-menu-down
                          </v-icon>
                        </v-col>
                        <v-col cols="1">
                          <md-icon
                            v-if="augmentableTheme"
                            class="md-size-x ml-n4 mt-n1"
                            md-src="/static/assets/svg/white/dracoIcon.svg"
                          />
                          <md-icon
                            v-if="!augmentableTheme"
                            class="md-size-x ml-n4 mt-n1"
                            md-src="/static/assets/svg/black/dracoIcon.svg"
                          />
                        </v-col>
                        <v-col cols="1" class="ml-2" style="cursor: pointer">
                          <v-icon class="mt-n2 ml-n5"> mdi-menu-right</v-icon>
                        </v-col>
                      </v-row>
                      <v-card
                        :style="{
                          background: $vuetify.theme.themes[theme].background,
                        }"
                        v-if="importmenu2"
                        elevation="0"
                        width="190"
                        min-height="150"
                        class="pr-1 mt-n3"
                      >
                        <div style="display: flex">
                          <p style="font-size: 11px" class="ml-4">UV's</p>
                          <v-spacer></v-spacer>
                          <v-checkbox class="mt-n2 mr-4"></v-checkbox>
                        </div>

                        <div style="display: flex" class="mt-n5">
                          <p style="font-size: 11px" class="ml-4">
                            Vertex Colors
                          </p>
                          <v-spacer></v-spacer>
                          <v-checkbox class="mt-n2 mr-4"></v-checkbox>
                        </div>

                        <div style="display: flex" class="mt-n5">
                          <p style="font-size: 11px" class="ml-4">Materials</p>
                          <v-spacer></v-spacer>
                          <v-checkbox class="mt-n2 mr-4"></v-checkbox>
                        </div>

                        <div style="display: flex" class="mt-n5">
                          <p style="font-size: 11px" class="ml-4">
                            Compression Level
                          </p>
                          <v-spacer></v-spacer>
                          <p style="font-size: 11px" class="mt-n1 mr-3">
                            <v-icon style="margin-top: -0.1em"
                              >navigate_before</v-icon
                            >8<v-icon style="margin-top: -0.1em"
                              >navigate_next</v-icon
                            >
                          </p>
                        </div>

                        <div style="display: flex" class="mt-n1">
                          <p style="font-size: 11px" class="ml-4">
                            Quantize position
                          </p>
                          <v-spacer></v-spacer>
                          <p style="font-size: 11px" class="mt-n1 mr-3">
                            <v-icon style="margin-top: -0.1em"
                              >navigate_before</v-icon
                            >8<v-icon style="margin-top: -0.1em"
                              >navigate_next</v-icon
                            >
                          </p>
                        </div>

                        <div style="display: flex" class="mt-n1">
                          <p style="font-size: 11px" class="ml-4">Normals</p>
                          <v-spacer></v-spacer>
                          <p style="font-size: 11px" class="mt-n1 mr-3">
                            <v-icon style="margin-top: -0.1em"
                              >navigate_before</v-icon
                            >8<v-icon style="margin-top: -0.1em"
                              >navigate_next</v-icon
                            >
                          </p>
                        </div>

                        <div style="display: flex" class="mt-n1">
                          <p style="font-size: 11px" class="ml-4">Tex Coord</p>
                          <v-spacer></v-spacer>
                          <p style="font-size: 11px" class="mt-n1 mr-3">
                            <v-icon style="margin-top: -0.1em"
                              >navigate_before</v-icon
                            >8<v-icon style="margin-top: -0.1em"
                              >navigate_next</v-icon
                            >
                          </p>
                        </div>

                        <div style="display: flex" class="mt-n1">
                          <p style="font-size: 11px" class="ml-4">Generic</p>
                          <v-spacer></v-spacer>
                          <p style="font-size: 11px" class="mt-n1 mr-3">
                            <v-icon style="margin-top: -0.1em"
                              >navigate_before</v-icon
                            >8<v-icon style="margin-top: -0.1em"
                              >navigate_next</v-icon
                            >
                          </p>
                        </div>
                        <v-btn
                          small
                          class="ml-4 mt-n1"
                          color="primary"
                          style="
                            border-radius: 15px;
                            height: 3vh !important;
                            width: 150px !important;
                            text-transform: none;
                          "
                          >Convert it</v-btn
                        >
                      </v-card>
                    </v-card>
                    <v-divider
                      vertical
                      style="border-color: #d3d3d3"
                      class="mt-4 mb-4"
                      v-if="importmenu3"
                    ></v-divider>
                    <!-- v-card3 -->
                    <v-card
                      :style="{
                        background: $vuetify.theme.themes[theme].background,
                      }"
                      v-if="importmenu3"
                      elevation="0"
                      min-width="130"
                      min-height="100"
                      style="overflow: hidden"
                      class="mt-3"
                    >
                      <v-row class="ml-3 mb-4">
                        <p style="font-weight: 660">Detail Settings</p>
                      </v-row>
                      <v-row
                        v-for="(item, index) in pickcompression"
                        :key="index"
                      >
                        <v-row
                          @click="checkExportFiles(item, index)"
                          class="mt-n8"
                        >
                          <v-col cols="1" class="ml-5">
                            <md-icon
                              v-if="augmentableTheme"
                              class="md-size-x"
                              style="cursor: pointer"
                              :md-src="item.svg1"
                            />
                            <md-icon
                              v-if="!augmentableTheme"
                              class="md-size-x"
                              style="cursor: pointer"
                              :md-src="item.svg2"
                            />
                          </v-col>
                          <v-col cols="7">
                            <p
                              class="caption-11 mt-1 ml-2"
                              style="
                                font-weight: 700;
                                opacity: 0.8;
                                cursor: pointer;
                              "
                            >
                              {{ item.name }}
                            </p>
                          </v-col>
                          <v-col cols="1">
                            <v-checkbox class="mt-n1"></v-checkbox>
                          </v-col>
                          <v-col cols="1"> </v-col>
                        </v-row>
                      </v-row>
                      <!-- <div
                        class="ml-2 mt-3"
                        v-for="(item, index) in pickcompression"
                        :key="index"
                      >
                        <div style="display: flex" class="mb-n7">
                          <p style="font-size: 10px; font-weight: 670">
                            {{ item.title }}
                          </p>
                          <v-spacer></v-spacer>
                          <v-checkbox class="mt-n2"></v-checkbox>
                        </div>
                      </div> -->
                    </v-card>
                    <!-- v-card for apipublish button  -->
                    <v-card
                      elevation="0"
                      width="170"
                      height="230"
                      color="transparent"
                      class="ma-0 pa-0"
                      v-if="apiPublish"
                    >
                      <p
                        style="
                          cursor: pointer;
                          color: #419cff;
                          font-weight: 700;
                        "
                        class="ma-0 pa-0 ml-3 mt-2 mb-5 mt-4"
                      >
                        Selected {{ selected1.length }}
                      </p>
                    </v-card>
                    <!-- v-card for sharepage button  -->
                    <v-card
                      elevation="0"
                      width="180"
                      min-height="180"
                      color="transparent"
                      class="ma-0 pa-0"
                      v-if="sharePage"
                    >
                      <p
                        style="
                          cursor: pointer;
                          color: #419cff;
                          font-weight: 700;
                        "
                        class="ma-0 pa-0 ml-3 mt-2 mb-5 mt-4"
                      >
                        Assests Selected {{ selected1.length }}
                      </p>
                      <!-- <v-card 
                    class="ml-4 mt-n1"
                     width="90"
                     height="90"
                     >
                     </v-card>
                     <div style="display:flex;" class="mb-3">
                       <div>
                      <div style="display:flex;" >
                     <h6 class="mt-n2 ml-3 ">16:9</h6>
                     <v-icon class=" mt-n4 ">mdi-menu-down</v-icon>
                    </div>
                    </div>
                    <v-spacer></v-spacer>
                    <div>
                      <div style="display:flex;">
                    <v-icon size="16" class=" mt-n2 ">mdi-view-parallel</v-icon>
                     <v-icon class=" mt-n2 ">mdi-menu-down</v-icon>
                    </div>
                    </div>
                    <v-spacer></v-spacer>
                     </div> -->
                      <v-text-field
                        outlined
                        dense
                        rounded
                        v-model="sharepageTitle"
                        class="ml-2 mr-2 mt-n1"
                        label="Page Title"
                      >
                      </v-text-field>
                      <!-- filedescription -->
                      <v-row class="ml-1 mt-n7 mb-3">
                        <v-col cols="8">
                          <p
                            style="
                              font-size: 11px;
                              font-weight: 700;
                              text-align: left;
                            "
                          >
                            File Description
                          </p>
                        </v-col>
                        <v-col cols="1">
                          <v-icon
                            class="ml-n1 mt-n2"
                            @click="filedescription = !filedescription"
                            >mdi-menu-down</v-icon
                          >
                        </v-col>
                      </v-row>
                      <div v-if="filedescription">
                        <v-row
                          class="ml-2 mt-n9"
                          v-for="(item, index) in filedescriptionData"
                          :key="index"
                        >
                          <v-col cols="8">
                            <p
                              class=""
                              style="
                                font-size: 9px;
                                font-weight: 600;
                                text-align: left;
                              "
                            >
                              {{ item.title }}
                            </p>
                          </v-col>
                          <v-col cols="2">
                            <v-checkbox
                              v-model="item.checked"
                              class="mt-n3 ml-n2"
                            ></v-checkbox>
                          </v-col>
                        </v-row>
                      </div>
                      <!-- viewerbacground -->
                      <v-row class="ml-1 mt-n10">
                        <v-col cols="8">
                          <p
                            style="
                              font-size: 11px;
                              font-weight: 700;
                              text-align: left;
                            "
                          >
                            Viewer Background
                          </p>
                        </v-col>
                        <v-col cols="1">
                          <v-icon
                            class="ml-n1 mt-n2"
                            @click="viewerbackground = !viewerbackground"
                            >mdi-menu-down</v-icon
                          >
                        </v-col>
                      </v-row>
                      <div v-if="viewerbackground">
                        <v-row
                          class="ml-2 mt-n7"
                          v-for="(item, index) in localitems3sharepage"
                          :key="index"
                        >
                          <v-col cols="8">
                            <p
                              class=""
                              style="
                                font-size: 9px;
                                font-weight: 600;
                                text-align: left;
                              "
                            >
                              {{ item.title }}
                            </p>
                          </v-col>
                          <v-col cols="2">
                            <v-icon class="mt-n3 ml-n1">{{ item.icon }}</v-icon>
                          </v-col>
                        </v-row>
                      </div>
                      <!-- viewerformate -->
                      <v-row class="ml-1 mt-n7">
                        <v-col cols="8">
                          <p
                            style="
                              font-size: 11px;
                              font-weight: 700;
                              text-align: left;
                            "
                          >
                            Viewer Format
                          </p>
                        </v-col>
                        <v-col cols="1">
                          <v-icon
                            class="ml-n1 mt-n2"
                            @click="viewerformate = !viewerformate"
                            >mdi-menu-down</v-icon
                          >
                        </v-col>
                      </v-row>
                      <div v-if="viewerformate">
                        <!-- <v-row
                          class="ml-2 mt-n7"
                          v-for="(item, index) in localitems5sharepage"
                          :key="index"
                        >
                          <v-col cols="7">
                            <p
                              class=""
                              style="
                                font-size: 9px;
                                font-weight: 600;
                                text-align: left;
                              "
                            >
                              {{ item.title }}
                            </p>
                          </v-col>
                          <v-col cols="2">
                            <div style="display: flex" class="ml-n2">
                              <p
                                style="font-size: 10px; margin-top: -0.3em"
                                v-if="item.check1"
                              >
                                16:9
                              </p>
                              <v-icon class="mt-n2" v-if="item.check2">{{
                                item.icon1
                              }}</v-icon>
                              <v-icon
                                style="margin-top: -0.3em; margin-left: -0.1em"
                                >{{ item.icon2 }}</v-icon
                              >
                            </div>
                          </v-col>
                        </v-row> -->
                        <div
                          class="ma-0 pa-0 mx-5 mt-n4 mb-3"
                          style="display: flex"
                        >
                          <div class="ma-0 pa-0">
                            <p style="font-size: 10px">Arrangement</p>
                          </div>
                          <v-spacer></v-spacer>
                          <div class="ma-0 pa-0 mt-n1">
                            <v-icon :size="selectedGridSharePage.iconsize">{{
                              selectedGridSharePage.icon
                            }}</v-icon>
                          </div>
                          <v-menu
                            rounded="lg"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            bottom
                            max-width="100"
                          >
                            <template v-slot:activator="{ on }">
                              <div class="ma-0 pa-0 mt-n1 mr-1">
                                <v-icon v-on="on">mdi-menu-down</v-icon>
                              </div>
                              <!-- <v-icon > mdi-menu-down </v-icon> -->
                            </template>
                            <v-card
                              class="ma-0 pa-0"
                              width="100"
                              height="100"
                              rounded="lg"
                              :style="{
                                background:
                                  $vuetify.theme.themes[theme].background,
                              }"
                              ><div class="pl-7 pr-7 pt-4 ma-0">
                                <div
                                  class="ma-0 pa-0"
                                  v-for="(item, i) in selectedGridSharePages"
                                  :key="i"
                                >
                                  <v-icon
                                    style="cursor: pointer"
                                    :size="item.iconsize"
                                    @click="changeSelectedGridSharePage(item)"
                                  >
                                    {{ item.icon }}
                                  </v-icon>
                                  <v-divider
                                    class="pl-5 pr-5"
                                    style="border-color: #d3d3d3"
                                  ></v-divider>
                                </div>
                              </div>
                            </v-card>
                          </v-menu>
                        </div>
                        <!-- <v-card class="ma-0 pa-0 mb-4" width="150" height="150">
                          <v-skeleton-loader
                            width="130"
                            height="130"
                            max-height="130"
                            max-width="130"
                            type="image,article"
                          ></v-skeleton-loader>
                        </v-card> -->
                      </div>

                      <!-- pagebackground -->
                      <v-row class="ml-1 mt-n7">
                        <v-col cols="8">
                          <p
                            style="
                              font-size: 11px;
                              font-weight: 700;
                              text-align: left;
                            "
                          >
                            Page Background
                          </p>
                        </v-col>
                        <v-col cols="1">
                          <v-icon
                            class="ml-n1 mt-n2"
                            @click="pagebackground = !pagebackground"
                            >mdi-menu-down</v-icon
                          >
                        </v-col>
                      </v-row>
                      <div v-if="pagebackground">
                        <v-row class="ml-2 mt-n7">
                          <v-col cols="8">
                            <p
                              class=""
                              style="
                                font-size: 9px;
                                font-weight: 600;
                                text-align: left;
                              "
                            >
                              Select Color
                            </p>
                          </v-col>

                          <v-col cols="2">
                            <v-icon
                              class="mt-n3 ml-n1"
                              :style="{ color: colorTag }"
                              @click="selectcolor = !selectcolor"
                              >mdi-circle</v-icon
                            >
                          </v-col>
                        </v-row>
                      </div>
                      <div v-if="pagebackground">
                        <v-row
                          class="ml-2 mt-n7"
                          v-for="(item, index) in localitems2sharepage"
                          :key="index"
                        >
                          <v-col cols="8">
                            <p
                              class=""
                              style="
                                font-size: 9px;
                                font-weight: 600;
                                text-align: left;
                              "
                            >
                              {{ item.title }}
                            </p>
                          </v-col>

                          <v-col cols="2">
                            <v-icon
                              class="mt-n3 ml-n1"
                              @click="pagebackgroundf(item.icon)"
                              >{{ item.icon }}</v-icon
                            >
                          </v-col>
                        </v-row>
                      </div>

                      <v-btn
                        @click="createSharePage()"
                        small
                        class="ml-2 mt-n4 mb-3"
                        color="primary"
                        style="
                          border-radius: 10px;
                          height: 2.3vh !important;
                          width: 150px !important;
                          text-transform: none;
                        "
                        >Save</v-btn
                      >
                    </v-card>
                    <!-- v-card for archive button  -->
                    <v-card
                      elevation="0"
                      width="170"
                      height="230"
                      color="transparent"
                      class="ma-0 pa-0"
                      v-if="archive"
                    >
                      <p
                        style="
                          cursor: pointer;
                          color: #419cff;
                          font-weight: 700;
                        "
                        class="ma-0 pa-0 ml-3 mt-2 mb-5 mt-4"
                      >
                        Selected {{ selected1.length }}
                      </p>
                      <div
                        class="mt-n7"
                        style="display: flex"
                        v-for="(item, index) in localitemarchive"
                        :key="index"
                      >
                        <v-row class="ml-3 mt-3">
                          <p
                            style="
                              font-size: 11px;
                              font-weight: 700;
                              text-align: left;
                            "
                          >
                            {{ item.title }}
                          </p>
                        </v-row>
                        <v-row justify="end" align="end" class="mt-n3 pr-6">
                          <v-checkbox class=""></v-checkbox>
                        </v-row>
                      </div>
                    </v-card>
                    <!-- v-card for delete button  -->
                    <v-card
                      elevation="0"
                      width="170"
                      height="230"
                      color="transparent"
                      class="ma-0 pa-0"
                      v-if="Delete"
                    >
                      <p
                        style="
                          cursor: pointer;
                          color: #419cff;
                          font-weight: 700;
                        "
                        class="ma-0 pa-0 ml-3 mt-2 mb-5 mt-4"
                      >
                        Selected {{ selected1.length }}
                      </p>
                      <div
                        class="mt-n7"
                        style="display: flex"
                        v-for="(item, index) in localitemdelete"
                        :key="index"
                      >
                        <v-row class="ml-3 mt-3">
                          <p
                            style="
                              font-size: 11px;
                              font-weight: 700;
                              text-align: left;
                              cursor: pointer;
                            "
                            @click="checkedTrueOfArray(localitemdelete, index)"
                          >
                            {{ item.title }}
                          </p>
                        </v-row>
                        <v-row justify="end" align="end" class="mt-n3 pr-6">
                          <v-checkbox
                            v-model="item.checked"
                            @click="checkedTrueOfArray(localitemdelete, index)"
                          ></v-checkbox>
                        </v-row>
                      </div>
                    </v-card>
                    <!-- end expand card 2 -->
                    <v-divider
                      vertical
                      style="border-color: #d3d3d3"
                      class="mt-3 mb-5"
                      v-if="selectcolor || viewerformate || uploadimage"
                    ></v-divider>
                    <!-- 3rd expand card -->
                    <v-card
                      elevation="0"
                      v-if="selectcolor || viewerformate || uploadimage"
                      color="transparent"
                      width="190"
                      min-height="200"
                    >
                      <v-card
                        elevation="0"
                        color="transparent"
                        class="mt-n4 pb-1"
                        v-if="viewerformate"
                      >
                        <p
                          class="ml-2"
                          style="font-size: 11px; font-weight: 660"
                        >
                          Page Preview
                        </p>
                        <v-card
                          elevation="0"
                          outlined
                          width="170"
                          height="140"
                          class="ml-2 mt-n2"
                        >
                        </v-card>
                      </v-card>
                      <div v-if="selectcolor" class="mt-n5">
                        <p
                          class="ml-2"
                          style="font-size: 11px; font-weight: 660"
                        >
                          Page Background Color
                        </p>
                        <div class="ml-2 mt-n1">
                          <v-color-picker
                            width="170"
                            hide-inputs
                            canvas-height="75"
                            v-model="colorTag"
                          ></v-color-picker>
                        </div>
                      </div>
                      <div v-if="uploadimage" class="mt-n1">
                        <p
                          class="ml-2"
                          style="font-size: 11px; font-weight: 660"
                        >
                          Upload Image
                        </p>
                        <v-card
                          width="170"
                          height="130"
                          class="ml-2 mt-n2 pb-n2"
                          elevation="0"
                          outlined
                        >
                        </v-card>
                      </div>
                    </v-card>
                  </div>
                </v-card>
              </v-menu>
            </div>
            <div class="ma-0 pa-0 mt-n2 ml-3">
              <v-text-field
                rounded
                outlined
                dense
                v-model="search"
                append-icon="search"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </div>
          </div>
          <!-- </v-col> -->

          <!-- <v-col cols="2" style="text-align: right"> -->
          <v-card
            tile
            elevation="0"
            width="170"
            class="ma-0 pa-0 mr-3 ml-5 pt-2"
            color="transparent"
          >
            <v-row class="ma-0 pa-0 pl-3" justify="start">
              <p
                class="ma-0 pa-0"
                style="font-size: 12px; font-weight: 800; opacity: 0.7"
              >
                Icon Size
              </p>
            </v-row>
            <v-row class="ma-0 pa-0 mt-n2" justify="end">
              <v-btn icon class="pt-1"
                ><v-icon size="17">mdi-square</v-icon></v-btn
              >
              <v-slider
                class="ma-0 pa-0 mt-1"
                v-model="iconRowSize"
                size="30"
                max="150"
                min="70"
                track-color="grey"
                track-fill-color="grey"
              ></v-slider>
              <v-btn icon
                ><v-icon size="30">mdi-checkbox-blank-outline</v-icon></v-btn
              >
            </v-row>
          </v-card>
          <!-- </v-col> -->
        </v-row>

        <v-divider style="border-color: #d3d3d3"></v-divider>
        <div class="ma-0 pa-0 mt-n6">
          <v-flex xs12 style="font-size">
            <!-- multi-sort 
                :sort-by="['created_at', 'filesize']"
              :sort-desc="[false, true]" -->
            <v-data-table
              :style="{
                background: $vuetify.theme.themes[theme].background,
              }"
              v-model="selected1"
              :headers="headers1"
              :items="serverItems"
              :search="search"
              :single-select="singleSelect"
              show-select
              item-key="filename"
              class="elevation-0"
              @click:row="handleClick"
              :custom-sort="customSort"
            >
              <template v-slot:[`item.filepng`]="{ item }">
                <v-tooltip left>
                  <template v-slot:activator="{ on }">
                    <v-layout v-on="on">
                      <hide-at breakpoint="small">
                        <v-img
                          style="filter: drop-shadow(0 0 0.5rem #808080)"
                          :src="item.filepng"
                          alt="File image"
                          :width="iconRowSize"
                          :height="iconRowSize"
                          contain
                          aspect-ratio="1"
                        ></v-img>
                      </hide-at>

                      <show-at breakpoint="small">
                        <v-img
                          style="filter: drop-shadow(0 0 0.5rem #808080)"
                          :src="item.filepng"
                          alt="File image"
                          width="80"
                          height="80"
                          contain
                          aspect-ratio="1"
                          class="mt-5"
                        ></v-img>
                      </show-at>
                    </v-layout>
                  </template>
                  <span>{{ item.filename }}</span>
                </v-tooltip>
              </template>
              <template v-slot:[`item.versions`]="{ item }">
                <p class="ma-0 pa-0" style="font-weight: 900">
                  {{ item.versions }} Versions
                </p>
              </template>
              <template v-slot:[`item.state`]="{ item }">
                <p
                  class="ma-0 pa-0"
                  v-if="item.state === 'inProgress'"
                  style="
                    color: #419cff;

                    font-weight: 900;
                  "
                >
                  {{ item.state }}
                </p>
                <p
                  class="ma-0 pa-0"
                  v-if="item.state !== 'inProgress'"
                  style="font-weight: 900"
                >
                  {{ item.state }}
                </p>
              </template>

              <template v-slot:[`item.tags`]="{ item }">
                <v-card
                  tile
                  class="ma-0 pa-0 mb-2 mt-1"
                  elevation="0"
                  width="200"
                  min-height="10"
                  color="transparent"
                >
                  <v-row class="ma-0 pa-0">
                    <v-chip
                      class="ml-1 mt-1"
                      small
                      :color="item1.color"
                      v-for="(item1, index) in item.tags"
                      :key="index"
                      dark
                      >{{ item1.title }}</v-chip
                    ></v-row
                  ></v-card
                >
              </template>
            </v-data-table>
          </v-flex>
        </div>
      </div>
    </div>
    <v-overlay :value="overlayP5">
      <v-progress-circular v-bind="spinnerProps"
        ><div>Zipping</div></v-progress-circular
      >
    </v-overlay>
  </div>
</template>

<script>
//import "../assets/scss/material-dashboard.scss";

import store from "../store";
import { mapState } from "vuex";
//import { mapGetters } from "vuex";
import axios from "axios";

axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
axios.defaults.xsrfCookieName = "csrftoken";

import { showAt, hideAt } from "vue-breakpoints";

import JSZip from "jszip";
import { saveAs } from "file-saver";

export default {
  components: {
    hideAt,
    showAt,
  },
  data: () => ({
    colorTag: "",
    selectcolor: false,
    uploadimage: false,
    filedescription: false,
    viewerbackground: false,
    viewerformate: false,
    pagebackground: false,
    download: false,
    convert: false,
    apiPublish: false,
    sharePage: false,
    archive: false,
    Delete: false,
    importmenu1: false,
    importmenu2: false,
    importmenu3: false,
    pickcompression: [
      {
        name: "No Draco (huge files)",
        checked: false,
        svg1: "/static/assets/svg/white/draco.svg",
        svg2: "/static/assets/svg/black/dracoIcon.svg",
      },
      {
        name: "USD (.usd)",
        checked: false,
        svg1: "/static/assets/svg/white/usd.svg",
        svg2: "/static/assets/svg/black/USDIcon.svg",
      },
      {
        name: "USDZ (.usdz)",
        checked: false,
        svg1: "/static/assets/svg/white/usdz.svg",
        svg2: "/static/assets/svg/black/USDZIcon.svg",
      },
      {
        name: "GLTF (.gltf)",
        checked: false,
        svg1: "/static/assets/svg/white/gltf.svg",
        svg2: "/static/assets/svg/black/USDZIcon.svg",
      },
      {
        name: "GLB (.glb)",
        checked: false,
        svg1: "/static/assets/svg/white/gltf.svg",
        svg2: "/static/assets/svg/black/USDZIcon.svg",
      },
    ],
    //sharePage
    sharepageTitle: "",
    //sharePage
    localitems1sharepage: [
      { title: "File name" },
      { title: "File description" },
      { title: "Combined" },
      { title: "Page Background" },
    ],
    localitems2sharepage: [
      { title: "Use HDRI", icon: "hdr_on" },
      { title: "Upload Image", icon: "mdi-upload-outline" },
    ],
    localitems3sharepage: [
      { title: "Select Color", icon: "palette_outlined" },
      { title: "Use HDRI", icon: "hdr_on" },
      { title: "Upload Image", icon: "mdi-upload-outline" },
    ],
    filedescriptionData: [
      { title: "Asset Name", checked: false },
      { title: "Asset Description", checked: false },
    ],
    localitems5sharepage: [
      { title: "Aspect ratio", icon2: "mdi-menu-down", check1: true },
      {
        title: "Arrangement",
        check2: true,
        icon1: "view_week",
        icon2: "mdi-menu-down",
      },
    ],
    selectedGridSharePage: {
      icon: "mdi-view-agenda",
      iconsize: "15",
      text: "JPG",
      value: "1",
    },
    selectedGridSharePages: [
      {
        icon: "mdi-view-agenda",
        iconsize: "16",
        text: "JPG",
        value: "1",
      },
      {
        icon: "mdi-view-grid",
        iconsize: "17",
        text: "JPG",
        value: "2",
      },
      {
        icon: "mdi-view-module",
        iconsize: "20",
        text: "PNG",
        value: "3",
      },
    ],
    localitemarchive: [{ title: "All versions" }, { title: "Latest versions" }],
    localitemdelete: [
      { title: "All versions", checked: true },
      { title: "Oldest version", checked: false },
      { title: "Latest version", checked: false },
    ],
    localitemdownload: [
      { title: "Original File" },
      { title: "GLB File" },
      { title: "USDZ File" },
      { title: "GLTF File" },
      { title: "Current version" },
      { title: "All  versions" },
    ],
    // pickcompression: [
    //   { title: "USDZ" },
    //   { title: "Draco" },
    //   { title: "Combined" },
    // ],
    quality: [
      { title: "low", minValue: 0, maxValue: 9, value: 2, checked: false },
      { title: "medium", minValue: 0, maxValue: 9, value: 2, checked: false },
      { title: "high", minValue: 0, maxValue: 9, value: 8, checked: true },
    ],
    compressionSetting: {
      title: "high",
      value: 10,
    },
    actionMenu: [
      {
        title: "Download",
        icon: "mdi-cloud-download-outline",
        checked: false,
      },
      {
        title: "Convert",
        icon: "mdi-merge",
        checked: false,
      },
      { title: "API Publish", icon: "mdi-api", checked: false },
      { title: "Sharepage", icon: "mdi-page-next-outline", checked: false },
      {
        title: "Archive",
        icon: "mdi-archive-arrow-down-outline",
        checked: false,
      },
      { title: "Delete", icon: "mdi-delete-outline", checked: false },
    ],

    serverItems: [],
    fileNamesofServer: [],

    overlayP5: false,
    spinnerProps: {
      color: "primary",
      value: 100,
      indeterminate: true,
      size: 80,
    },
    //iconRowSize: "",
    interval: "",

    itemClick: false,
    actionClick: false,

    singleSelect: false,
    selected1: [],
    search: "",
    dialog: false,
    headers1: [
      {
        text: "File",
        align: "center",
        sortable: false,
        value: "filepng",
      },
      { text: "Versions", value: "versions", sortable: true },
      { text: "Filesize", value: "filesize", sortable: true },
      { text: "Filetype", value: "filetype", sortable: false },
      {
        text: "Name",
        align: "start",
        sortable: false,
        value: "filename",
      },
      //{ text: "Version", value: "version" },

      { text: "State", value: "state", sortable: false },
      { text: "Uploaded", value: "created_at", sortable: true },

      { text: "Tags", value: "tags", sortable: false },

      //{ text: "Auther", value: "added_by" },

      //{ text: "Actions", value: "actions", sortable: false },
    ],
    desserts: [
      {
        id: 1,
        filepng: "static/assets/images/screenshot.png",
        fileglb: "static/assets/images/Superstar_v20.glb",
        filename: "Shoe",
        tags: ["priority", "fix", "urgent", "share", "urgent"],
        added_by: "admin",
        state: "inProgress",
        created_at: new Date(),
        description: "this is first description",
        filesize: "50MB",
        filetype: "GLB",
      },
      {
        id: 2,
        filepng: "static/assets/images/screenshot.png",
        fileglb: "static/assets/images/Superstar_v20.glb",
        filename: "Snikkers",
        tags: ["priority", "fix", "urgent"],
        added_by: "admin",
        state: "onHold",
        created_at: new Date(),
        description: "this is 2nd description",
        filesize: "50MB",
        filetype: "GLB",
      },
      {
        id: 3,
        filepng: "static/assets/images/screenshot.png",
        fileglb: "static/assets/images/Superstar_v20.glb",
        filename: "Bag",
        tags: ["priority", "fix", "urgent", "share", "urgent", "share"],
        added_by: "admin",
        state: "complete",
        created_at: new Date(),
        description: "this is 3rd description",
        filesize: "50MB",
        filetype: "GLB",
      },
      {
        id: 4,
        filepng: "static/assets/images/screenshot.png",
        fileglb: "static/assets/images/Superstar_v20.glb",
        filename: "Bottle",
        tags: ["priority", "fix", "urgent", "share", "urgent", "share"],
        added_by: "admin",
        state: "onHold",
        created_at: new Date(),
        description: "this is 4th description",
        filesize: "50MB",
        filetype: "GLB",
      },
      {
        id: 5,
        filepng: "static/assets/images/screenshot.png",
        fileglb: "static/assets/images/Superstar_v20.glb",
        filename: "Joggers",
        tags: ["priority", "fix", "urgent", "share", "urgent", "share"],
        added_by: "foo",
        state: "complete",
        created_at: new Date(),
        description: "this is 5th description",
        filesize: "50MB",
        filetype: "GLB",
      },
      {
        id: 6,
        filepng: "static/assets/images/screenshot.png",
        fileglb: "static/assets/images/Superstar_v20.glb",
        filename: "ShoeKit",
        tags: ["priority", "fix", "urgent", "share", "urgent", "share"],
        added_by: "foo",
        state: "complete",
        created_at: new Date(),
        description: "this is 6th description",
        filesize: "50MB",
        filetype: "GLB",
      },
      {
        id: 7,
        filepng: "static/assets/images/screenshot.png",
        fileglb: "static/assets/images/Superstar_v20.glb",
        filename: "SportKit",
        tags: ["priority", "fix", "share"],
        added_by: "admin",
        state: "onHold",
        created_at: new Date(),
        description: "this is 7th description",
        filesize: "50MB",
        filetype: "GLB",
      },
      {
        id: 8,
        filepng: "static/assets/images/screenshot.png",
        fileglb: "static/assets/images/AF03BA001_GG1073.glb",
        filename: "Glasses",
        tags: ["priority"],
        added_by: "foo",
        state: "inQueue",
        created_at: new Date(),
        description: "this is 8th description",
        filesize: "50MB",
        filetype: "GLB",
      },
      {
        id: 9,
        filepng: "static/assets/images/screenshot.png",
        fileglb: "static/assets/images/Astronaut.glb",
        filename: "SocarShoes",
        tags: ["priority", "fix", "urgent", "share", "urgent", "share"],
        added_by: "foo",
        state: "inProgress",
        created_at: new Date(),
        description: "this is 9th description",
        filesize: "50MB",
        filetype: "GLB",
      },
      {
        id: 10,
        filepng: "static/assets/images/screenshot.png",
        fileglb: "static/assets/images/Superstar_v20.glb",
        filename: "Football",
        tags: ["priority", "fix", "urgent", "share"],
        added_by: "admin",
        state: "onHold",
        created_at: new Date(),
        description: "this is 10th description",
        filesize: "50MB",
        filetype: "GLB",
      },
    ],

    show_start_date: false,
    start_date: null,

    show_end_date: false,
    end_date: null,

    filters: {
      search: "",
      added_by: "",
      start_date: null,
      end_date: null,
    },
    authors: ["Admin", "Foo"],
    pagination: {
      sortBy: "name",
    },
    multipleFiles: [],

    //collected
    collectedVersions: [],
    collectedAssets: [],
  }),
  // //watch
  watch: {
    // iconrowSize: function (val) {
    //   this.$store.commit("setIconRowSize", val);
    // },
  },
  //computed
  computed: {
    ...mapState(["augmentableTheme"]),
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },

    // ...mapState(["iconrowSize"]),

    iconRowSize: {
      get() {
        return store.state.iconrowSize;
      },
      set(val) {
        this.$store.commit("setIconRowSize", val);
      },
    },
  },

  //mounted
  mounted() {
    this.getAllFilesFromServer();

    this.$root.$on("glbAssetsGetAllfiles", () => {
      this.getAllFilesFromServer();
    });
  },
  methods: {
    pagebackgroundf(x) {
      if (x === "mdi-upload-outline") {
        this.uploadimage = !this.uploadimage;
      }
    },
    makeMultipleFileLink() {
      var i;
      var len;

      for (i = 0, len = this.selected1.length; i < len; i++) {
        this.multipleFiles.push(this.selected1[i].shareLink);
      }

      console.log(this.multipleFiles);

      var myJSON = JSON.stringify(this.multipleFiles);
      console.log(myJSON);
      this.multipleFiles = [];
    },
    delete1(x) {
      console.log(x);
    },
    // deleteFilesWait() {
    //   this.interval = setInterval(this.deleteFiles, 200, this.collectedAssets);
    // },
    deleteFilesWait(items) {
      this.interval = setInterval(this.deleteFiles, 200, items);
    },
    deleteFiles(items) {
      var item = items.shift();

      axios
        .delete(
          this.$abServerPath + "/api/glbfiles/glbdeletefile/" + item.id + "/",
          {
            headers: {
              Authorization:
                "Token " + this.getAuthCookie("augmentableUserToken") + "",
            },
          }
        )
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          console.log(error);
        });

      if (items.length == 0) {
        clearInterval(this.interval);
        this.selected1 = [];
        this.getAllFilesFromServer();
      }
    },
    deleteFiles1() {
      var i;
      var len;

      console.log("uuuu");
      console.log(this.collectedAssets);
      console.log(this.collectedAssets.length);

      for (i = 0, len = this.collectedAssets.length; i < len; i++) {
        // console.log(
        //   this.collectedAssets[i].filename + this.selected1[i].id + ""
        // );
        console.log("oooo");
        //this.multipleFiles.push(this.collectedAssets[i].shareLink);
        axios
          .delete(
            this.$abServerPath +
              "/api/glbfiles/glbdeletefile/" +
              this.collectedAssets[i].id +
              "/",
            {
              headers: {
                Authorization:
                  "Token " + this.getAuthCookie("augmentableUserToken") + "",
              },
            }
          )
          .then((response) => {
            console.log(response.status);
          })
          .catch((error) => {
            console.log(error);
            //this.errored = true;
          });
      }
    },

    addfile() {
      this.$router.push({ path: "/addFile" });
    },
    addversion() {
      this.$router.push({ path: "/addVersion" });
    },
    goToTheSharePages() {
      this.$router.push({ path: "/sharepages" });
    },

    createSharePage() {
      var assets = this.collectVersionsIDs(1);
      var assetsID = [];

      for (var i = 0; i < assets.length; i++) {
        assetsID.push(assets[i].id);
      }
      // console.log(assetsID);
      var grids = JSON.stringify(this.selectedGridSharePage);
      var assetsIDs = JSON.stringify(assetsID);

      let formData = new FormData();

      formData.append("pagetitle", this.sharepageTitle);
      formData.append("state", "unProcessed");
      formData.append("tags", "");
      formData.append("description", "");
      formData.append("grids", grids);
      formData.append("showFileName", this.filedescriptionData[0].checked);
      formData.append(
        "showFileDescription",
        this.filedescriptionData[1].checked
      );
      formData.append("fileIDs", assetsIDs);

      axios
        .post(
          this.$abServerPath + "/api/sharepages/glbpostsharepage/",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization:
                "Token " + this.getAuthCookie("augmentableUserToken") + "",
            },
          }
        )
        .then((response) => {
          console.log(response.data);
          this.goToTheSharePages();
          console.log("SUCCESS!!");
        })
        .catch((error) => {
          console.log(error);
          console.log("ffff");
        });
    },

    getStateColor(state) {
      if (state === "inProgress") return "light-blue";
      else if (state === "onHold") return "red";
      else if (state === "complete") return "green";
      else if (state === "inQueue") return "orange";
      else return "green";
    },

    getTagsColor(tags) {
      if (tags === "priority") return "red";
      else if (tags === "urgent") return "light-blue";
      else if (tags === "share") return "green";
      else if (tags === "fix") return "orange";
      else return "green";
    },

    getColor(calories) {
      if (calories > 400) return "red";
      else if (calories > 200) return "orange";
      else return "green";
    },
    getAuthCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },

    handleClick(item) {
      if (this.actionClick === true) {
        this.actionClick = false;
        return;
      }

      var item1 = {
        filename: "",
        filepng: "",
        fileglb: "",
        fileusdz: "",
        filetype: "",
        tags: "",
        state: "",
        created_at: "",
        description: "",
        id: "",
        filesize: "",
        version: "",
        slug: "",
        password_required: "",
        updatedThumbnail: false,
        fileConfig: "",

        //extra
        active: "",
      };

      item1.filename = item.filename;
      item1.filepng = item.filepng;
      item1.fileglb = item.fileglb;
      item1.fileusdz = item.fileusdz;
      item1.filetype = item.filetype;
      item1.tags = item.tags;
      item1.state = item.state;
      item1.created_at = item.created_at;
      item1.description = item.description;
      item1.id = item.id;
      item1.version = item.version;
      item1.filesize = item.filesize;

      item1.slug = item.slug;
      item1.password_required = item.password_required;
      item1.updatedThumbnail = item.updatedThumbnail;
      item1.fileConfig = item.fileConfig;

      //extra for activeness
      item1.active = true;
      //extra for activeness

      this.$store.commit("setFileDetail", item1);

      this.$router.push({
        name: "File Detail",
        params: { slug: store.state.fileDetail.slug },
      });
    },

    editItem(item) {
      this.actionClick = true;

      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.actionClick = true;
      console.log(item.id);

      confirm("Are you sure you want to delete this item?") &&
        this.deleteServerItem(item.id);
    },

    deleteServerItem(y) {
      console.log(y);
      console.log("Delete");

      axios
        .delete(this.$abServerPath + "/api/glbfiles/glbdeletefile/" + y + "/", {
          headers: {
            Authorization:
              "Token " + this.getAuthCookie("augmentableUserToken") + "",
          },
        })
        .then((response) => {
          console.log(response);

          this.getAllFilesFromServer();
        })
        .catch((error) => {
          console.log(error);
          //this.errored = true;
        });
    },

    getAllFilesFromServer() {
      this.fileNamesofServer = [];
      this.serverItems = [];
      axios
        .get(this.$abServerPath + "/api/glbfiles/glbgetallfile/", {
          headers: {
            "Content-Type": "application/json",
            Authorization:
              "Token " + this.getAuthCookie("augmentableUserToken") + "",
          },
        })
        .then((response) => {
          var i;
          var len;

          var item = {
            id: "",
            slug: "",
            filename: "",
            filetype: "",
            fileglb: "",

            filepng: "",
            filesize: "",
            created_at: "",
            updated_at: "",
            tags: "",
            state: "",
            description: "",
            version: "",
            fileusdz: "",
            password_required: "",
            updatedThumbnail: false,
            fileConfig: "",
            versions: 1,
            versionsIDs: [],
          };

          for (i = 0, len = response.data.length; i < len; i++) {
            item = response.data[i];
            item.id = response.data[i].id;
            item.slug = response.data[i].slug;
            item.filename = response.data[i].filename;
            item.filetype = response.data[i].filetype.toUpperCase();
            item.fileglb = this.$abServerPath + "" + response.data[i].fileglb;
            item.filepng = this.$abServerPath + "" + response.data[i].filepng;
            item.fileusdz = this.$abServerPath + "" + response.data[i].fileusdz;
            item.filesize = response.data[i].filesize;
            item.created_at = this.dateFormat(response.data[i].created_at);
            item.updated_at = response.data[i].updated_at;

            if (response.data[i].tags.charAt(0) === "[") {
              //for new tag objects
              item.tags = JSON.parse(response.data[i].tags);
            } else {
              //for previous tags when they were string not objects
              var obj = {
                title: "",
                color: "",
              };
              obj.title = response.data[i].tags;
              obj.color = "#ADD8E6";
              item.tags = [];
              //added lately
              if (obj.title !== "") {
                //item.tags.push(obj);
                item.tags.unshift(obj);
              }
              //added lately

              //item.tags.push(obj);
            }
            item.state = response.data[i].state;
            item.description = response.data[i].description;
            item.version = response.data[i].version;

            item.password_required = response.data[i].password_required;

            item.updatedThumbnail = response.data[i].updatedThumbnail;

            if (response.data[i].fileConfig) {
              item.fileConfig = JSON.parse(response.data[i].fileConfig);
            } else {
              item.fileConfig = "";
            }

            // if (this.fileNamesofServer.includes(response.data[i].filename)) {
            //   var index = this.serverItems.findIndex(
            //     (x) => x.filename === response.data[i].filename
            //   );
            //   this.serverItems[index].versions =
            //     this.serverItems[index].versions + 1;
            //   continue;
            // }

            var obj1 = {
              id: "",
              filename: "",
              fileglb: "",
              filepng: "",
              fileusdz: "",

              version: "",
              filetype: "",
            };
            obj1.id = item.id;
            obj1.filename = item.filename;
            obj1.fileglb = item.fileglb;
            obj1.filetype = item.filetype;
            obj1.version = item.version;

            if (this.fileNamesofServer.includes(response.data[i].filename)) {
              var index = this.serverItems.findIndex(
                (x) => x.filename === response.data[i].filename
              );
              this.serverItems[index].versions =
                this.serverItems[index].versions + 1;
              // this.serverItems[index].versionsIDs.push(obj1);
              this.serverItems[index].versionsIDs.unshift(obj1);

              continue;
            }

            item.versions = 1;

            item.versionsIDs = [];
            // item.versionsIDs.push(obj1);
            item.versionsIDs.unshift(obj1);

            // this.fileNamesofServer.push(response.data[i].filename);
            // this.serverItems.push(item);
            this.fileNamesofServer.unshift(response.data[i].filename);
            this.serverItems.unshift(item);
          }
        })
        .catch((error) => {
          console.log(error);
          //this.errored = true;
        });
    },

    collectVersions(file) {
      this.collectedVersions = [];
      axios
        .get(
          this.$abServerPath +
            "/api/glbfiles/glbgetfileversions/" +
            file.filename +
            "/",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization:
                "Token " + this.getAuthCookie("augmentableUserToken") + "",
            },
          }
        )
        .then((response) => {
          //console.log(response.data);

          var i;
          var len;

          var item = {
            id: "",
            slug: "",
            filename: "",
            filetype: "",
            fileglb: "",
            filepng: "",
            filesize: "",
            created_at: "",
            updated_at: "",
            tags: "",
            state: "",
            fileusdz: "",
            description: "",
            version: "",
          };

          for (i = 0, len = response.data.length; i < len; i++) {
            item = response.data[i];
            item.id = response.data[i].id;
            item.slug = response.data[i].slug;
            item.filename = response.data[i].filename;
            item.filetype = response.data[i].filetype;
            item.fileglb = this.$abServerPath + "" + response.data[i].fileglb;
            item.filepng = this.$abServerPath + "" + response.data[i].filepng;
            item.fileusdz = this.$abServerPath + "" + response.data[i].fileusdz;
            item.filesize = response.data[i].filesize;
            item.created_at = this.dateFormat(response.data[i].created_at);
            item.updated_at = response.data[i].updated_at;
            if (response.data[i].tags.charAt(0) === "[") {
              //for new tag objects
              item.tags = JSON.parse(response.data[i].tags);
            } else {
              //for previous tags when they were string not objects
              var obj = {
                title: "",
                color: "",
              };
              obj.title = response.data[i].tags;
              obj.color = "#ADD8E6";
              item.tags = [];
              item.tags.push(obj);
            }
            item.state = response.data[i].state;

            item.description = response.data[i].description;
            item.version = response.data[i].version;
            this.collectedVersions.push(item);
          }
          //console.log(collectedVersions);
          //return collectedVersions;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    checkQualityValues(item) {
      var index = this.quality.findIndex((x) => x.title === item.title);
      var i;
      var len;
      for (i = 0, len = this.quality.length; i < len; i++) {
        if (index === i) {
          this.quality[i].checked = true;
        } else {
          this.quality[i].checked = false;
        }
        this.compressionSetting.title = this.quality[index].title;
        this.compressionSetting.value = this.quality[index].value;
      }
    },
    minquality(y) {
      if (y.value > 0) {
        y.value = y.value - 1;
        var index = this.quality.findIndex((x) => x.title === y.title);
        this.quality[index].value = y.value;
      }
    },
    maxquality(y) {
      if (y.value < 10) {
        y.value = y.value + 1;
        var index = this.quality.findIndex((x) => x.title === y.title);
        this.quality[index].value = y.value;
      }
    },
    changeSelectedGridSharePage(item) {
      this.selectedGridSharePage = item;
    },
    collectAssets1(x) {
      var i;
      var len;
      for (i = 0, len = this.actionMenu.length; i < len; i++) {
        if (x === i) {
          this.actionMenu[i].checked = true;
        } else {
          this.actionMenu[i].checked = false;
        }
      }

      if (x === 0) {
        this.download = !this.download;
        this.convert = false;
        this.apiPublish = false;
        this.sharePage = false;
        this.archive = false;
        this.Delete = false;
        this.selectcolor = false;
        this.viewerformate = false;
        this.uploadimage = false;
        this.importmenu3 = false;
      } else if (x === 1) {
        this.convert = !this.convert;
        this.download = false;
        this.apiPublish = false;
        this.sharePage = false;
        this.archive = false;
        this.Delete = false;
        this.selectcolor = false;
        this.viewerformate = false;
        this.uploadimage = false;
        this.importmenu3 = false;
      } else if (x === 2) {
        this.apiPublish = !this.apiPublish;
        this.download = false;
        this.convert = false;
        this.sharePage = false;
        this.archive = false;
        this.Delete = false;
        this.selectcolor = false;
        this.viewerformate = false;
        this.uploadimage = false;
        this.importmenu3 = false;
      } else if (x === 3) {
        this.sharePage = !this.sharePage;
        this.download = false;
        this.convert = false;
        this.apiPublish = false;
        this.archive = false;
        this.Delete = false;
        this.selectcolor = false;
        this.viewerformate = false;
        this.uploadimage = false;
        this.importmenu3 = false;
      } else if (x === 4) {
        this.archive = !this.archive;
        this.download = false;
        this.convert = false;
        this.apiPublish = false;
        this.sharePage = false;
        this.Delete = false;
        this.selectcolor = false;
        this.viewerformate = false;
        this.uploadimage = false;
        this.importmenu3 = false;
      } else if (x === 5) {
        this.Delete = !this.Delete;
        this.download = false;
        this.convert = false;
        this.apiPublish = false;
        this.sharePage = false;
        this.archive = false;
        this.selectcolor = false;
        this.viewerformate = false;
        this.uploadimage = false;
        this.importmenu3 = false;
      }
    },
    collectAssets(x) {
      this.collectedAssets = [];
      if (x === 6) {
        let title = this.findTitleOfCheckedValue(this.localitemdelete);
        let deleteItems = [];
        if (title === "All versions") {
          deleteItems = this.collectVersionsIDs(1);
        } else if (title === "Oldest version") {
          deleteItems = this.collectVersionsIDs(2);
        } else if (title === "Latest version") {
          deleteItems = this.collectVersionsIDs(3);
        }
        confirm("Are you sure you want to delete this item?") &&
          this.deleteFilesWait(deleteItems);
      }
      //console.log(this.selected1);
      var check = 0;
      var compare = this.selected1.length - 1;
      var iEx;
      var lenEx;
      for (iEx = 0, lenEx = this.selected1.length; iEx < lenEx; iEx++) {
        check = iEx;
        axios
          .get(
            this.$abServerPath +
              "/api/glbfiles/glbgetfileversions/" +
              this.selected1[iEx].filename +
              "/",
            {
              headers: {
                "Content-Type": "application/json",
                Authorization:
                  "Token " + this.getAuthCookie("augmentableUserToken") + "",
              },
            }
          )
          .then((response) => {
            //console.log(response.data);

            var i;
            var len;

            var item = {
              id: "",
              slug: "",
              filename: "",
              filetype: "",
              fileglb: "",
              filepng: "",
              filesize: "",
              created_at: "",
              updated_at: "",
              tags: "",
              state: "",
              description: "",
              version: "",
            };

            for (i = 0, len = response.data.length; i < len; i++) {
              item = response.data[i];
              item.id = response.data[i].id;
              item.slug = response.data[i].slug;
              item.filename = response.data[i].filename;
              item.filetype = response.data[i].filetype;
              item.fileglb = this.$abServerPath + "" + response.data[i].fileglb;
              item.filepng = this.$abServerPath + "" + response.data[i].filepng;
              item.fileusdz =
                this.$abServerPath + "" + response.data[i].fileudz;
              item.filesize = response.data[i].filesize;
              item.created_at = this.dateFormat(response.data[i].created_at);
              item.updated_at = response.data[i].updated_at;
              if (response.data[i].tags.charAt(0) === "[") {
                //for new tag objects
                item.tags = JSON.parse(response.data[i].tags);
              } else {
                //for previous tags when they were string not objects
                var obj = {
                  title: "",
                  color: "",
                };
                obj.title = response.data[i].tags;
                obj.color = "#ADD8E6";
                item.tags = [];
                item.tags.push(obj);
              }
              item.state = response.data[i].state;

              item.description = response.data[i].description;
              item.version = response.data[i].version;
              this.collectedAssets.push(item);
            }
          })
          .catch((error) => {
            console.log(error);
          });

        if (check === compare) {
          //console.log(this.collectedAssets.length);
          if (x === 1) {
            this.downloadFiles();
          } else if (x === 2) {
            console.log("hi");
          }
          // else if (x === 6) {
          //   confirm("Are you sure you want to delete this item?") &&
          //     this.deleteFilesWait();

          //   // this.getAllFilesFromServer();
          // }
          else if (x === 5) {
            this.zip();
          }
        }
      }
    },

    checkedTrueOfArray(items, index) {
      let i;
      let len;
      for (i = 0, len = items.length; i < len; i++) {
        if (i === index) {
          items[i].checked = true;
        } else {
          items[i].checked = false;
        }
      }
    },
    findTitleOfCheckedValue(items) {
      var index = items.findIndex((x) => x.checked === true);
      return items[index].title;
    },
    collectVersionsIDs(x) {
      //x represents the all,oldest,latest with 1/2/3
      let versionsIDs = [];
      let i;
      let len;
      let iIn;
      let lenIn;
      for (i = 0, len = this.selected1.length; i < len; i++) {
        for (
          iIn = 0, lenIn = this.selected1[i].versionsIDs.length;
          iIn < lenIn;
          iIn++
        ) {
          if (x === 1) {
            versionsIDs.push(this.selected1[i].versionsIDs[iIn]);
          } else if (x === 2) {
            versionsIDs.push(this.selected1[i].versionsIDs[0]);
            break;
          } else if (x === 3) {
            versionsIDs.push(this.selected1[i].versionsIDs[lenIn - 1]);
            break;
          }
        }
      }
      return versionsIDs;
    },

    customSort(items, index, isDesc) {
      items.sort((a, b) => {
        if (index[0] == "created_at") {
          if (!isDesc[0]) {
            let t = this.bigDate(b[index], a[index]);
            return t;
          } else {
            let t = this.bigDate(a[index], b[index]);
            return t;
          }
        } else if (index[0] == "filesize") {
          if (!isDesc[0]) {
            let t = this.bigSize(b[index], a[index]);
            return t;
          } else {
            let t = this.bigSize(a[index], b[index]);
            return t;
          }
        } else if (index[0] == "versions") {
          if (!isDesc[0]) {
            return b[index] - a[index];
          } else {
            return a[index] - b[index];
          }
        } else {
          if (typeof a[index] !== "undefined") {
            if (!isDesc[0]) {
              return a[index]
                .toLowerCase()
                .localeCompare(b[index].toLowerCase());
            } else {
              return b[index]
                .toLowerCase()
                .localeCompare(a[index].toLowerCase());
            }
          }
          // if (typeof a[index] === "undefined") {
          //   console.log(a);
          //   console.log(b);
          //   return a[index];
          // }
        }
      });
      return items;
    },

    bigDate(a, b) {
      var a1 = a.split(".");
      var b1 = b.split(".");
      var a2 = a1[2] + a1[1] + a1[0];
      var b2 = b1[2] + b1[1] + b1[0];
      var r = parseInt(a2) - parseInt(b2);
      //number is positive or not
      return r;
    },
    bigSize(a, b) {
      var a1 = a.split("MB");
      var b1 = b.split("MB");
      var r = parseFloat(a1[0]) * 1024 * 1024 - parseFloat(b1[0]) * 1024 * 1024;
      //number is positive or not
      return r;
    },

    async zip() {
      this.overlayP5 = true;
      var zip = new JSZip();
      var i;
      var len;
      var j;
      var len1;
      //files = [];
      //console.log(this.selected1.length);
      for (i = 0, len = this.selected1.length; i < len; i++) {
        console.log(this.selected1[i].versionsIDs);
        for (
          j = 0, len1 = this.selected1[i].versionsIDs.length;
          j < len1;
          j++
        ) {
          console.log(this.selected1[i].versionsIDs[j].id);
          //     var link = document.createElement("a");
          var downloadName =
            this.selected1[i].versionsIDs[j].filename +
            "_V" +
            this.selected1[i].versionsIDs[j].version +
            "." +
            this.selected1[i].versionsIDs[j].filetype;

          let file = await fetch(this.selected1[i].versionsIDs[j].fileglb)
            .then((r) => r.blob())
            .then((blobFile) => new File([blobFile], "" + downloadName));

          zip.file(file.name, file);
          //zip.file(this.file2.name, this.file2);
          // zip.file(this.file3.name, this.file3);
          // files.push(file);
          console.log("hhhhh");
          console.log(file);

          // link.download = file.name;
          // link.href = URL.createObjectURL(file);

          // link.click();
        }
      }

      zip
        .generateAsync({
          type: "blob",
          compression: "DEFLATE",
          compressionOptions: {
            level: 9,
          },
        })
        .then(function (content) {
          // see FileSaver.js
          saveAs(content, "file.zip");
          this.overlayP5 = false;
        })
        .catch((error) => {
          console.log(error);
          //this.errored = true;

          this.overlayP5 = false;
        });
      // for(i=0,len=;;i++)
      // this.file1 = this.$refs.file1.files[0];
      // //console.log(this.file1);
      // this.file2 = this.$refs.file2.files[0];
      // //console.log(this.file2);
      // this.file3 = this.$refs.file3.files[0];
      // //console.log(this.file3);
      // zip.file(this.file1.name, this.file1);
      // zip.file(this.file2.name, this.file2);
      // zip.file(this.file3.name, this.file3);
      // //for folder creation inside zip
      // // var img = zip.folder("images");
      // // img.file("smile.gif", imgData, {base64: true});
      // zip
      //   .generateAsync({
      //     type: "blob",
      //     compression: "DEFLATE",
      //     compressionOptions: {
      //       level: 9,
      //     },
      //   })
      //   .then(function (content) {
      //     // see FileSaver.js
      //     saveAs(content, "file.zip");
      //   });
    },

    // zip() {
    //   //we can't access multiple files downoad directoly
    //   this.interval = setInterval(
    //     this.downloadLinks,
    //     300,
    //     this.collectedAssets
    //   );
    // },

    downloadFiles() {
      //we can't access multiple files downoad directoly
      this.interval = setInterval(
        this.downloadLinks,
        300,
        this.collectedAssets
      );
    },
    async downloadLinks(items) {
      var item = items.shift();
      var link = document.createElement("a");
      var downloadName =
        item.filename + "_V" + item.version + "." + item.filetype;

      let file = await fetch(item.fileglb)
        .then((r) => r.blob())
        .then((blobFile) => new File([blobFile], "" + downloadName));

      link.download = file.name;
      link.href = URL.createObjectURL(file);
      // var downloadName = item.filename+"-V"+item.version;
      // console.log(downloadName);
      // link.download = "export.glb";
      // link.href = item.fileglb;
      link.click();

      if (items.length == 0) {
        clearInterval(this.interval);
        this.selected1 = [];
      }
    },

    dateFormat(x) {
      return (
        "" + x.slice(8, 10) + "." + x.slice(5, 7) + "." + x.slice(0, 4) + ""
      );
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
      console.log(this.$sidebar.showSidebar);
    },

    goToBabylon() {
      this.$router.push({ path: "/babylonTest" });
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.desserts[this.editedIndex], this.editedItem);
      } else {
        this.desserts.push(this.editedItem);
      }
      this.close();
    },

    customFilter(items, filters, filter, headers) {
      // Init the filter class.
      const cf = new this.$MultiFilters(items, filters, filter, headers);
      // Use regular function(),
      // arrow functions does not allow context binding.
      // Register the global standard filter.
      cf.registerFilter("search", function (searchWord, items) {
        if (searchWord.trim() === "") return items;
        return items.filter((item) => {
          return item.name.toLowerCase().includes(searchWord.toLowerCase());
        }, searchWord);
      });
      // Use regular function(),
      // arrow functions does not allow context binding.
      // Register "added_by" filter.
      cf.registerFilter("added_by", function (added_by, items) {
        // If the filter has not been applied yet
        // just return all available items.
        if (added_by.trim() === "") return items;
        // Compare each item added_by and just return the matching ones.
        return items.filter((item) => {
          return item.added_by.toLowerCase() === added_by.toLowerCase();
        }, added_by);
      });
      // Use regular function(),
      // arrow functions does not allow context binding.
      // Register "start_date" filter.
      cf.registerFilter("start_date", function (start_date, items) {
        // If the filter has not been applied yet
        // just return all available items.
        if (start_date === null) return items;
        // Compare each item start_date and just return the matching ones.
        return items.filter((item) => {
          return item.birth_date >= start_date;
        }, start_date);
      });
      // Use regular function(),
      // arrow functions does not allow context binding.
      // Register "end_date" filter.
      cf.registerFilter("end_date", function (end_date, items) {
        // If the filter has not been applied yet
        // just return all available items.
        if (end_date === null) return items;
        // Compare each item end_date and just return the matching ones.
        return items.filter((item) => {
          return item.birth_date <= end_date;
        }, end_date);
      });
      // Its time to run all created filters.
      // Will be executed in the order thay were defined.
      return cf.runFilters();
    },
    /**
     * Toggle selected items with the master checkbox.
     */
    toggleAll() {
      if (this.selected.length) {
        this.selected = [];
      } else {
        this.selected = this.rows.slice();
      }
    },
    /**
     * Column shorting.
     *
     * @param column
     */
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    /**
     * Handler when user input something at the "Filter" text field.
     */
    filterSearch(val) {
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        search: val,
      });
    },
    /**
     * Handler when user  select some author at the "Author" select.
     */
    filterAuthor(val) {
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        added_by: val,
      });
      console.log(this.filters);
    },
    /**
     * Handler when select a date on "From" date picker.
     */
    filterStartDate(val) {
      // Close the date picker.
      this.$refs.show_start_date.save(val);
      //Convert the value to a timestamp before saving it.
      const timestamp = new Date(val + "T00:00:00Z").getTime();
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        start_date: timestamp,
      });
    },
    /**
     * Handler when select a date on "To" date picker.
     */
    filterEndDate(val) {
      // Close the date picker.
      this.$refs.show_end_date.save(val);
      //Convert the value to a timestamp before saving it.
      const timestamp = new Date(val + "T00:00:00Z").getTime();
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        end_date: timestamp,
      });
    },
    multipleFilesTab() {
      this.$router.push({ path: "/batchImport" });
    },
  },
  filters: {
    /**
     * Format a timestamp into a d/m/yyy (because spanish format).
     *
     * @param value
     * @returns {string}
     */
    formatDate: function (value) {
      if (!value) return "";
      return new Date(value).toLocaleDateString("es-ES");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/material-dashboard.scss";

// .v-text-field .v-input__control .v-input__slot {
//   min-height: 10px !important;
//   display: flex !important;
//   align-items: center !important;
// }

.v-input {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}

// table.v-table tbody td {
//   height: 40px;
//   border: none;
// }

// .v-table tbody td {
//   border-collapse: collapse;
// }

// table {
//   border-collapse: collapse;
// } // remove border

// .mytable table tr {
//   background-color: lightgoldenrodyellow;
//   border-bottom: none !important;
// }

// .v-data-table {
//   //border: 1px solid red !important;

//   border-collapse: collapse !important;
// }

.table tbody tr {
  border-bottom: none !important;
}

// .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
//   font-size: 50px !important;
// }

.v-data-table table tbody tr {
  border-bottom: none !important;
}

// .v-data-table > .v-data-table__wrapper > table tbody > tr td {
//   font-size: 50px !important;
//   font-size: 2rem !important;
// }

// .v-data-table {
//   border: 1px solid red !important;
// }
.darkOutline.v-btn--outlined {
  border: thin solid rgba(#ededed, 0.5);
}
.lightOutline.v-btn--outlined {
  border: thin solid rgba(#303030, 0.5);
}
</style>
